import { useLocalCameraTrack } from "agora-rtc-react";
import { useEffect, useRef } from "react";

const LocalVideoView = ({ isCameraOn }) => {
    const { localCameraTrack } = useLocalCameraTrack({ cameraId: "", encoderConfig: "480p" });
    const hasPlayed = useRef(false);

    useEffect(() => {
        if (!localCameraTrack) return;

        const playerContainer = document.getElementById("local-player");

        // Handle when camera is turned on
        if (isCameraOn) {
            if (!hasPlayed.current) {
                localCameraTrack.play("local-player");
                hasPlayed.current = true;
            }
        } else {
            if (localCameraTrack) {
                localCameraTrack.stop(); // Stop camera when off
            }
            if (playerContainer) {
                playerContainer.innerHTML = ""; // Clear the player container
            }
            hasPlayed.current = false;
        }

        return () => {
            if (localCameraTrack) {
                localCameraTrack.stop(); // Cleanup when unmounting
            }
            if (playerContainer) {
                playerContainer.innerHTML = "";
            }
            hasPlayed.current = false;
        };
    }, [localCameraTrack, isCameraOn]);

    return <div id="local-player" className="w-100 h-100" />;
};

export default LocalVideoView;
